import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

/** Bank info response body - DTO signature*/
export interface BankFindInterface {
  /** Bank UUID. Cannot be changed. */
  id: string;

  // Tech columns
  /** Bank creation date and time */
  created: Date;
  /** Bank creation date and time */
  updated: Date;
  /** Bank creation date and time */
  deleted?: Date;

  // Data columns
  /** Bank full name */
  name: string;
  /** Bank RCBIC */
  rcbic: string;
  /** Bank correspondent account number */
  correspondentAccount: string;
  /** Bank city name */
  city?: string;
  /** Bank post index */
  index?: string;
  /** Russian Business and Organization Classification (OKPO, rus. "ОКПО") code for bank */
  rboc?: string;
  /** Bank address */
  address?: string;

  // Version columns
  /** Data version */
  version: Date;
  /** Is bank data expired */
  expired?: boolean;
}

/** Bank info response body - DTO schema */
export const BankFindDto = SerdeDtoClass.create<BankFindInterface>(CatalogDtosKeysEnum.BANK_FIND_DTO, {
  id: {
    label: 'Номер',
    hint: 'UUID',
    serializer: yup.string(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  name: {
    label: 'Название',
    serializer: yup.string(),
  },
  rcbic: {
    label: 'БИК',
    serializer: yup.string(),
  },
  correspondentAccount: {
    label: 'Корреспондентский счет',
    serializer: yup.string(),
  },
  city: {
    optional: true,
    label: 'Город',
    serializer: yup.string(),
  },
  index: {
    optional: true,
    label: 'Почтовый индекс',
    serializer: yup.string(),
  },
  rboc: {
    optional: true,
    label: 'ОКПО',
    serializer: yup.string(),
  },
  address: {
    optional: true,
    label: 'Адрес',
    serializer: yup.string(),
  },
  version: {
    label: 'Версия',
    serializer: yup.date(),
  },
  expired: {
    optional: true,
    label: 'Информация устарела',
    hint: 'В "bik-info" данный банк был удален или не найден',
    serializer: yup.boolean(),
  },
});
